import dayjs from 'dayjs';

export function normalizeAllDay(event: {
  start: Date | string;
  end?: Date | string;
  allDay?: boolean;
}): any {
  if (!event.allDay) return event;

  const startOfDay = dayjs(event.start).startOf('day');

  const endSrc = event.end ? dayjs(event.end) : startOfDay;
  const en = endSrc.startOf('day');
  const endExclusive = en.isAfter(startOfDay) ? en.toDate() : startOfDay.add(1, 'day').toDate();

  return {
    ...event,
    start: startOfDay.toDate(),
    end: endExclusive,
  };
}
